import { render, staticRenderFns } from "./listView.vue?vue&type=template&id=0567fe67&"
import script from "./listView.vue?vue&type=script&lang=js&"
export * from "./listView.vue?vue&type=script&lang=js&"
import style0 from "./listView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports